import { render, staticRenderFns } from "./AuthComponent.vue?vue&type=template&id=21824eaa&scoped=true&"
import script from "./AuthComponent.vue?vue&type=script&lang=ts&"
export * from "./AuthComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AuthComponent.vue?vue&type=style&index=0&id=21824eaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21824eaa",
  null
  
)

export default component.exports